import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
const NAMES = ['María', 'Juan', 'Lucía', 'Carlos', 'Ana', 'Pedro', 'Sofía', 'Marcos', 'Valentina', 'Gabriel', 'Carolina', 'Andrés', 'Paula', 'Fernando', 'Camila'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén', 'Bahía Blanca', 'San Juan', 'Corrientes', 'Resistencia', 'Posadas'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 5000);
    const interval = setInterval(() => {
      const randomDelay = Math.floor(Math.random() * 4000) + 8000;
      setTimeout(showPopup, randomDelay);
    }, 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-379">
      {isVisible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-4 left-4 z-40 bg-white rounded-lg shadow-xl p-4 max-w-xs border-l-4 border-[#22c55e] flex items-center gap-3" data-id="element-380">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-381">
            <ShoppingCartIcon className="w-5 h-5 text-[#22c55e]" data-id="element-382" />
          </div>
          <div data-id="element-383">
            <p className="text-sm font-bold text-gray-800" data-id="element-384">
              {currentData.name} de {currentData.city}
            </p>
            <p className="text-xs text-gray-600" data-id="element-385">
              acaba de comprar el Kit de Educación Financiera
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-386">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}